export const convertSecondsToMinutesAndSeconds = (totalSeconds: number) => {
	const minutes = Math.floor(totalSeconds / 60);
	const seconds = totalSeconds % 60;
	return {
		minutes,
		seconds,
	};
};

export const convertMinutesAndSecondsToSeconds = (minutes: number, seconds: number) => {
	return minutes * 60 + seconds;
};

export const formatTime = (time: number) => {
	return time.toString().padStart(2, '0');
};
